import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search',
    standalone: false
})
export class SearchPipe implements PipeTransform {

  transform(searchListing: any[], searchTxt: string): any[] {
    if (!searchListing?.length) return [];
    if (!searchTxt?.trim()?.length) return searchListing;

    const lowerSearch = searchTxt.toLowerCase();

    return searchListing.filter(item => {
      // Combine possible searchable fields
      const name = item.name || '';
      const first = item.firstname || '';
      const last = item.lastname || '';

      const combined = `${name} ${first} ${last}`.toLowerCase();

      return combined.includes(lowerSearch);
    });
  }

}
